<template>
    <a-row>
        <a-col :span="4">
        </a-col>
        <a-col :span="16">
            <a-form-model :model="record" ref="ruleForm2" :rules="rules" :layout="formItemLayout">
                <p><a-icon type="notification" style="color:#1890ff" /> 模板中可替换变量格式：{{keyname}}</p>
                <a-form-model-item ref="templatetitle" label="通知标题" prop="templatetitle">
                    <a-input v-if="is_vue_task" v-model="record.templatetitle"
                        @blur="() => {$refs.templatetitle.onFieldBlur();}" />
                    <span v-else>{{record.templatetitle}}</span>
                </a-form-model-item>

                <a-form-model-item ref="templatecontent" label="通知内容" prop="templatecontent">
                    <a-input type="textarea" v-if="is_vue_task && passwayCode != 'PASSTYPE-001'" v-model="record.templatecontent"
                        @blur="() => {$refs.templatecontent.onFieldBlur();}" />

                    <QEditor v-if="is_vue_task && passwayCode == 'PASSTYPE-001'" :height="200" v-model="record.templatecontent" @blur="() => {$refs.templatecontent.onFieldBlur();}"></QEditor>

                    <span v-else>{{record.templatecontent}}</span>
                </a-form-model-item>

                <div class="filedBox">
                    <div class="filedLabel">
                        <span>附加字段</span>

                        <span class="addBtn" @click="handleAdd" v-if="is_vue_task" >
                            <a-icon class="box_icon"  type="plus-square" />
                            添加
                        </span>
                    </div>

                    <div class="filedsItem" v-for="(item) in extraData" :key="item.uid">
                        <a-input :placeholder="templeteKey" v-model="item.key" max-length="50"  v-if="is_vue_task" />
                        <span v-else>{{item.key}}</span>
                        ：
                        <a-input :placeholder="templeteValue" v-model="item.value" max-length="100"  v-if="is_vue_task" />
                        <span v-else>{{item.value}}</span>

                        <a-icon class="box_icon_minus" @click="handleReduce(item.uid)"  type="minus-square" v-if="is_vue_task"  />
                    </div>
                </div>

            </a-form-model>

        </a-col>
    </a-row>

</template>
<script>

import QEditor from '@/components/QEditor/QEditor'
export default {
    components:{
        QEditor
    },
    data() {
        return {
            formItemLayout:'vertical',
            rules: {
                templatetitle: [
                    { required: true, message: ' 请输通知标题，限100字 ', trigger: 'blur' },
                    { min: 1, max: 100, message: '请输入1~100个字符', trigger: 'blur' },
                ],
                templatecontent:[
                    { required: true, message: ' 请输通知内容，限500字', trigger: 'blur' },
                    // { min: 1, max: 500, message: '请输入1~500个字符', trigger: 'blur' },
                ],
            },
            extraData:[],
            record:{},
            is_vue_task:false,
            keyname:'{{keyname}}',
            templeteKey:'{{key1}}键',
            templeteValue:'{{value1}}值',
            passwayCode:''
        };
    },

    methods: {
        changePasswayCode(passwayCode){
            this.passwayCode = passwayCode
        },
        loadData(record,is_vue_task){
            this.is_vue_task = is_vue_task;
            this.record = record;
            let tempData = [];
            if(record.templateextras){
                tempData = JSON.parse(record.templateextras)
            }
            else{
                tempData = [
                ];
            }
            tempData.forEach(element => {
                element.uid = this.G.generateUUID();
            });
            this.extraData = tempData;
        },
        handleAdd(){
            if(this.extraData.length == 10){
                this.message.info("最多可添加10条");
                return;
            }
            let tuid = this.G.generateUUID();
            this.extraData.push({
                uid:tuid,
                key:'',
                value:''
            });
        },
        getExtraStr(){
            let valid_ = true;
            this.$refs.ruleForm2.validate(valid => {
                valid_ = valid;
            });
            if (valid_) {
                let tempResult = this.extraData.filter((item) => {return (item.key && item.value)});
                let extras = [];
                tempResult.forEach(element => {
                    extras.push({
                        key:element.key,
                        value:element.value
                    })
                });

                let result = {
                    templatetitle:this.record.templatetitle,
                    templatecontent:this.record.templatecontent,
                    templateextras:JSON.stringify(extras),
                }
                let reg = /\{{.*?\}}/g;
                let Extras1 =  result.templatetitle.match(reg);
                let Extras2 =  result.templatecontent.match(reg);
                let Extras3 =  result.templateextras.match(reg);
                let AllExtras = [];
                if(Extras1){
                    AllExtras = AllExtras.concat(Extras1)
                }
                if(Extras2){
                    AllExtras = AllExtras.concat(Extras2)
                }
                if(Extras3){
                    AllExtras = AllExtras.concat(Extras3)
                }
                result.templatevariables=AllExtras.join(',').replaceAll('{{','').replaceAll('}}','')
                return result;
            } else {
                console.log('error submit!!');
                return false;
            }
        },
        handleReduce(uid){
            this.extraData = this.extraData.filter((item) => {return item.uid != uid});
        },
        resetForm(){
            this.record.templatetitle = "";
            this.record.templatecontent = "";
            this.extraData = [];
        }
    },
    mounted(){
  
    },
 
 
};
</script>

<style scoped>


.filedsItem input{
    width:180px;
}

.filedBox{
    width: 420px;
}
.filedLabel{
    margin-bottom: 10px;
}
.addBtn{
    float: right;
    cursor: pointer;
    color: #1890ff;
    user-select: none;
}

.box_icon_minus{
    color: red;
    margin-left: 10px;
    cursor: pointer;
}
.filedsItem{
    margin-bottom: 18px;
}

</style>
